export default {
  namespaced: true,

  state() {
    return {
      assessment_code: null,
      accept_level: null,
      navigator_model_params: [],
      norm_groups: [],
      report_options: [],
      report_scales: [],
      pdf_report_types: [],
      pdf_report_options: [],
      saved: true
    };
  },

  mutations: {
    set_state(
      state,
      {
        assessment_code = null,
        accept_level = null,
        navigator_model_params = [],
        norm_groups = [],
        report_options = [],
        report_scales = [],
        pdf_report_types = [],
        pdf_report_options = [],
        saved = true
      }
    ) {
      state.assessment_code = assessment_code;
      state.accept_level = accept_level;
      state.navigator_model_params = navigator_model_params;
      state.norm_groups = norm_groups;
      state.report_options = report_options;
      state.report_scales = report_scales;
      state.pdf_report_types = pdf_report_types;
      state.pdf_report_options = pdf_report_options;
      state.saved = saved;
    },

    set_key_value(state, { key, value }) {
      state[key] = value;
    }
  },

  getters: {
    assessment: state => state
  }
};
